// import AddTab from './add-tab';
import EditTab from './edit-session-tabs';
import './tab-layouts.scss';

const TabLayouts: React.FC = () => {

	return (
		<div className="session-tab-layout">
			<div className="session-tab-layout-header">
				<div className="session-tab-layout-title">Tabs</div>
				<div className="session-tab-buttons">
					{/* commenting out for now: will need to figure out how to incorporate into the edit tab functionality for reusable code */}
					{/* <AddTab /> */}
					<EditTab />
				</div>
			</div>
			<div className="session-tab-layout-body"></div>
		</div>
	);
};

export default TabLayouts;
